import cn from 'classnames';
import { MaterialIcon } from 'components/modulab/MaterialIcon';
import { mobileNavigationButtonClassName } from '../constants';

type DesktopMonthNavigationProps = {
  canGoToPreviousMonth: boolean;
  canGoToNextMonth: boolean;
  onPreviousMonthClick: () => void;
  onNextMonthClick: () => void;
  previousMonthLabel: string;
  nextMonthLabel: string;
};

/**
 * ‹ › month navigation on the outer edges of the desktop dual calendar
 * (CMS-1853 Req 5). Both months move together; previous is disabled once the
 * current month is shown.
 */
export function DesktopMonthNavigation({
  canGoToPreviousMonth,
  canGoToNextMonth,
  onPreviousMonthClick,
  onNextMonthClick,
  previousMonthLabel,
  nextMonthLabel,
}: DesktopMonthNavigationProps): JSX.Element {
  return (
    <>
      <button
        type="button"
        onClick={onPreviousMonthClick}
        disabled={!canGoToPreviousMonth}
        className={cn(
          mobileNavigationButtonClassName,
          'absolute left-0 top-0 disabled:opacity-50',
        )}
        aria-label={previousMonthLabel}
      >
        <MaterialIcon icon="chevron_left" />
      </button>
      <button
        type="button"
        onClick={onNextMonthClick}
        disabled={!canGoToNextMonth}
        className={cn(
          mobileNavigationButtonClassName,
          'absolute right-0 top-0 disabled:opacity-50',
        )}
        aria-label={nextMonthLabel}
      >
        <MaterialIcon icon="chevron_right" />
      </button>
    </>
  );
}
